import React, { FC } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Tabs as MuiTabs, Tab } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';

import { PublicUserProfileFragment } from 'api';
import * as paths from 'paths';
import { generateLink } from 'Links';

interface IProps {
  profile: PublicUserProfileFragment;
}

interface IPropsEnhanced extends IProps, WithStyles<typeof styles>, RouteComponentProps {}

const styles = () =>
  createStyles({
    root: {
      borderBottom: 0,
    },
  });

const enhancers = compose<IPropsEnhanced, IProps>(withRouter, withStyles(styles));

const Tabs: FC<IPropsEnhanced> = ({ classes, profile, match }) => {
  const { t } = useTranslation();

  const ActivityLink = generateLink(`/profile/${profile.id}`);
  const GroupsLink = generateLink(`/profile/${profile.id}/groups`);
  const FollowingLink = generateLink(`/profile/${profile.id}/following`);
  const FollowersLink = generateLink(`/profile/${profile.id}/followers`);

  return (
    <MuiTabs value={match.path} className={classes.root}>
      <Tab label={t('common:activity')} value={paths.profile} component={ActivityLink} />
      <Tab label={t('common:group_plural')} value={paths.profileGroups} component={GroupsLink} />
      <Tab label={t('common:following')} value={paths.profileFollowing} component={FollowingLink} />
      <Tab
        label={t('common:follower_plural')}
        value={paths.profileFollowers}
        component={FollowersLink}
      />
    </MuiTabs>
  );
};

export default enhancers(Tabs);
